<template>
  <validation-observer ref="simpleRules">
    <p>* Es importante que tanto el id curso moodle <b>"en campus"</b> como <b>"en moodle"</b> deben ser iguales para que ambas plataformas esten sincronizadas y se pueda extraer la información correctamente como las "calificaciones"</p>

    <hr>
    <hr>
    <h4 class="text-primary">
      Datos Campus Virtual
    </h4>
    <h5 class="text-left">
      Nombre de la materia: {{ cursoData.materia_nombre }}
    </h5>
    <h5 class="text-right">
      Periodo {{ cursoData.periodoClaveCampus }}
    </h5>
    <h5 class="text-left">
      Id curso campus virtual: {{ cursoData.id_curso_campus }}
    </h5>
    <h5 class="text-left">
      Id curso moodle en <b>"Campus" :</b> {{ cursoData.mdl_id }}
    </h5>
    <hr>
    <hr>
    <h4 class="text-warning">
      Datos Plataforma Moodle
    </h4>
    <h5 class="text-left">
      Id curso moodle en <b>"Moodle" :</b> {{ cursoData.id }}
    </h5>
    <h5 class="text-left">
      Nombre del curso: {{ cursoData.nombre }}
    </h5>
    <b-form class="mt-1">
      <b-form-group
        label="ID Moodle para el curso en campus virtual"
        label-for="idmoodle"
      >
        <validation-provider
          #default="{ errors }"
          name="idmoosle"
          rules="integer"
        >
          <b-input-group>
            <b-form-input
              v-model="idmoodle"
              :state="errors.length > 0 ? false:null"
              autocomplete="off"
              :disabled="bandera"
            />
            <b-input-group-append>
              <b-button
                variant="outline-primary"
                @click="validationForm(idmoodle)"
              ><feather-icon
                :icon="returnIcon(bandera)"
              /></b-button>
            </b-input-group-append>
          </b-input-group>
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>
    </b-form>
  </validation-observer>
</template>

<script>
import {
  BFormInput,
  BFormGroup,
  BInputGroup,
  BButton,
  BInputGroupAppend,
  BForm,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { integer } from '@validations'

export default {
  components: {
    BFormInput,
    BButton,
    BInputGroup,
    BFormGroup,
    BInputGroupAppend,
    BForm,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    cursoData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      idmoodle: null,
      bandera: true,
      integer,
    }
  },
  created() {
    if (this.cursoData.mdl_id != null) this.idmoodle = this.cursoData.mdl_id
  },
  methods: {
    guardar() {
      this.bandera = false
    },
    returnIcon(dato) {
      return dato === false ? 'SaveIcon' : 'Edit3Icon'
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.guardar()
        }
      })
    },
  },
}
</script>
